import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { getSessionRatingsApi } from "../../redux/session/sessionApi";
import { formatDateTime } from "../../helper/helper";

const SessionRatingList = ({ sessionId }) => {
    const [ratings, setRatings] = useState([]);

    useEffect(() => {
        if (!sessionId) return;

        getSessionRatingsApi(sessionId)
            .then((res) => {
                setRatings(res.data?.data?.items || []);
            })
            .catch(() => setRatings([]));
    }, [sessionId]);

    const renderStars = (rating) => {
        const value = Math.round(Number(rating || 0));
        return "★".repeat(value) + "☆".repeat(5 - value);
    };

    return (
        <div className="card shadow-sm border-0 radius-16 p-16 h-100">

            <div className="d-flex align-items-center gap-8 mb-16">
                <div
                    className="d-flex align-items-center justify-content-center bg-warning text-white rounded-circle"
                    style={{ width: 36, height: 36 }}
                >
                    <Icon icon="mdi:star-outline" />
                </div>

                <h6 className="fw-semibold mb-0">Session Ratings</h6>
            </div>

            {ratings.length === 0 ? (
                <div className="text-center text-secondary py-20">
                    No ratings available
                </div>
            ) : (

                <div style={{ maxHeight: 300, overflowY: "auto" }}>

                    {ratings.map((r) => (

                        <div
                            key={r.id}
                            className="border radius-12 p-12 mb-12 bg-light hover-shadow"
                        >

                            <div className="d-flex justify-content-between align-items-center mb-6">

                                <div>
                                    <div className="fw-semibold text-dark">
                                        {r?.User?.fullName || "User"}
                                    </div>

                                    <div className="text-xs text-secondary">
                                        {r?.User?.designation || ""}
                                    </div>
                                </div>

                                <div className="text-warning fw-semibold">
                                    {renderStars(r.rating)}
                                </div>

                            </div>

                            {r.comment && (
                                <div className="text-sm text-secondary">
                                    {r.comment}
                                </div>
                            )}

                            <div className="text-xs text-muted mt-4">
                                {formatDateTime(r.createdAt)}
                            </div>

                        </div>

                    ))}

                </div>
            )}
        </div>
    );
};

export default SessionRatingList;